<!--
 * @Author: 朱占伟
 * @LastEditors: 晋睿敏
 * @description: 公共顶部; 相关配置项参考 navConfig属性
 * @Date: 2021-07-23 18:22:55
 * @LastEditTime: 2022-03-11 19:46:19
 * @remark:右侧可以配置文本以及监听事件
-->
<template>
  <div>
    <div v-if="config.type !== PAGETYPES.HIDE" class="header">
      <van-nav-bar :title="headerTitle" :placeholder="navConfig.fixed" :fixed="navConfig.fixed">
        <template #left>
          <!-- 内容页展示 -->
          <van-icon v-if="navConfig.leftArrow" name="arrow-left" size="18" color="#6153FF" @click="goBack" />
          <!-- 首页展示 -->
          <a v-if="config.type === PAGETYPES.HOME" class="logo" @click="goWebsiteHomePage" />
        </template>
        <template #right>
          <div v-if="config.type === PAGETYPES.HOME && !getCloseGuide && showCloseGuide" class="user-guidance-gift" @click="openUserGuidanceDialog">
            <lottie-anim :src="dataJson" />
          </div>
          <div v-if="config.type === PAGETYPES.HOME" class="msg-icon">
          
            <img src="images/home/notice-iocn.svg" :class="{ bell:isActive }" dot @click="sendAction">
            <sup v-if="store.state.user.hasUnread <10 && store.state.user.hasUnread >0" style="right: -3px" class="msg-notice">{{ store.state.user.hasUnread }}</sup>
            <sup v-else-if="store.state.user.hasUnread >=10 && store.state.user.hasUnread <=99" style="right: -3px" class="msg-notice">{{ store.state.user.hasUnread }}</sup>
            <sup v-else-if="store.state.user.hasUnread >99" style="right: -7px" class="msg-notice">99+</sup>
            <van-dialog 
              v-model:show="showNotice"
              :show-confirm-button="false"
              :overlay="false"
            >
              You have an unread message,please check it
            </van-dialog>
          </div>
          <div v-if="showOrderOff" class="first-order">
            <img src="images/home/first-order.svg">
            <div class="first-order-title">50% OFF on 1st Order</div>
          </div>
          <van-icon
            v-if="config.type === 'order'||config.isHaveReset"
            name="replay"
            style="margin-right: 2px; color: #6153ff;"
          />
          <div
            v-if="config.actionTitle"
            class="action-title"
            @click="sendAction"
          >{{ config.actionTitle || "" }}</div>
        </template>
      </van-nav-bar>
    </div>
  </div>
</template>

<script>
import { reactive ,ref, onMounted ,computed} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { PAGETYPES } from './config';
import { useStore } from 'vuex'
import event from 'utils/eventBus';
import dataJson from "../../assets/json/gift.json";
import { post } from '../../utils/request.js'


export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          callBackName: '', //返回操作自定义事件名
          type: 'home', // 頁面類型
          title: '', // 頁面標題
          actionEvent: '', // 执行事件名
          actionTitle: '', // 右侧事件文本名
          isHaveReset:false
        };
      }
    }
  },
  setup(props) {
    const visible = ref(false);
    const isActive = ref(false)
    const route = useRoute();
    const router = useRouter();
    const store = useStore()
    const showCloseGuide = ref(false)
    const navConfig = reactive({
      fixed: true,
      zindex: 99,
      leftArrow: true // 左侧返回上一步icon
    });
    const headerTitle = computed(() => {
      return props.config.title
    })

    // 判断当前页面类型
    const getPageType = () => {
      if (props.config.type === 'home') {
        navConfig.leftArrow = false;
      } else if (props.config.type === 'tabar' || props.config.type === 'order') {
        navConfig.leftArrow = false;
      } else {
        navConfig.leftArrow = true;
      }
    };
    
    // 返回上一级
    const goBack = () => {
      store.commit('dashboard/setIsIosMoveBack', false)
      if (props.config.callBackName) {
        return event.$emit(props.config.callBackName);
      } else {
        return router.go(-1);
      }
    };
    //消息通知
    const onBell = () => {
      const harMessage = store.state.user.hasUnread
      if(harMessage > 0) {
        visible.value = true
        setTimeout(() => {
          visible.value = false
          isActive.value = true
          store.commit('dashboard/sethasNotice',true)
        },2000)
      }
    }
    const showNotice=computed(()=>{
      return visible.value && !store.state.dashboard.hasNotice
    })
    getPageType();

    const showOrderOff=computed(()=>{
      return store.state.dashboard.firstOrderInfo.data && visible.value === false && route.path === '/wap/home'
    })
    // 触发全局监听
    const sendAction = () => {
      props.config.actionEvent && event.$emit(props.config.actionEvent);
      isActive.value = false
    };
    
    //跳到官网首页
    const goWebsiteHomePage = () =>{
      location.replace("/")
    }
    
    const getCloseGuide = computed(() => {
      // return window.$mine.closeGuide
      return !!store.state.user.mine.closeGuide
    });
    const openUserGuidanceDialog = () => {
      event.$emit('openUserGuidanceDialog', true)
    }

    // 初始化获取页面类型

    const init = async () => {
      if(props.config.type === PAGETYPES.HOME && !getCloseGuide.value) {
        const resp = await post('User/checkGuide')
        if (resp.code===0 && resp.data) {
          if (resp.data.step) {
            if (resp.data.step === -1) {
              store.commit('user/setMine', {...window.$mine, closeGuide: true})
              showCloseGuide.value = false
            } else {
              showCloseGuide.value = true
            }
          }
        }
      }
    }

    
    onMounted(()=>{
      onBell()
      init()
    })


    return {
      headerTitle,
      sendAction,
      PAGETYPES,
      router,
      route,
      navConfig,
      goBack,
      store,
      visible,
      isActive,
      onBell,
      showNotice,
      goWebsiteHomePage,
      showOrderOff,
      dataJson,
      getCloseGuide,
      openUserGuidanceDialog,
      showCloseGuide
    };
  },
  methods() { }
};
</script>
<style lang="scss" scoped>
.bell  {
  width: 18px;
  height: 18px;
  position: relative;
   transform-origin: top center;
  animation: bellring 2s ease infinite;
  @keyframes bellring {
          0% { transform: rotate(0); }
          10% { transform: rotate(8deg); }
          20% { transform: rotate(-8deg); }
          30% { transform: rotate(6deg); }
          40% { transform: rotate(-6deg); }
          50% { transform: rotate(4deg); }
          60% { transform: rotate(-4deg); }
          70% { transform: rotate(2deg); }
          80% { transform: rotate(-2deg); }
          100% { transform: rotate(0); }
    }
}

.action-title {
  color: $main;
  font-size: 14px;
}

.logo {
  width: 135px;
  display: inline-block;
  height: 20px;
  background: url("assets/images/logo.svg") no-repeat;
  background-size: 100%;
}

.header {
  position: relative;
  z-index: 999;
  height: 50px;
}

.user-guidance-gift {
  margin-right: 20px;
  position: relative;
  top: -8px;
  width: 36px;
  height: 28px;
}

.msg-icon {
  position: relative;
   right: 10px;
  .msg-notice {
    background-color: #F56C6C;
    border-radius: 10px;
    color: #FFF;
    display: inline-block;
    height: 13px;
    line-height: 13px;
    padding: 0 3px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #FFF
  }
}
:deep(.van-dialog) {
  background-color: rgb(30, 24, 63);
  border: none;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  padding: 10px 5px;
  left: calc(100vw - 11.5rem);
  top: 60px;
  white-space: nowrap;
  width: 20rem;
  z-index: 99999;
}
.first-order{
  width: 194px;
  height: 32px;
  background-color: #FFF5E8;
  border: 1px solid #FF8A29;
  position: fixed;
  z-index: 999 !important;
  right: 15px;
  top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 17px;
  &>img{
    width: 16px;
  }
  .first-order-title{
    font-size: 14px;
    font-weight: 600;
    color: #FF8A29;
    margin-left: 3px;
  }
}

</style>


